// extracted by mini-css-extract-plugin
export default {"table":"UserDonationTable_table__FH4mZ"};